<script lang="ts" setup>
import { THEME, PROVIDE_THEME } from '@pkg/config/misc/theme';
import type { ProvideThemeInjection } from '@pkg/config/misc/theme';
import { provide, ref, watch } from 'vue';
import { cn } from '@pkg/ui/lib/utils';

/**
 * Minimal section chrome for business (shared MainHero / SubHeroSection host).
 * Visual chrome (padding / colours) lives in `assets/css/sectionTheme.css.ts`.
 * Web keeps a richer PartialSection with surprise-bag theme overrides.
 */
const props = defineProps<{
  theme: THEME;
  anchor?: string;
}>();

const sectionTheme = ref<THEME>(props.theme);
watch(() => props.theme, (theme) => {
  sectionTheme.value = theme;
});

provide(PROVIDE_THEME, {
  theme: sectionTheme,
  setTheme: (newTheme: THEME) => {
    sectionTheme.value = newTheme;
  },
} satisfies ProvideThemeInjection);
</script>

<template>
  <section
    :id="anchor ? anchor : undefined"
    :class="cn('c-section', { 'c-section--app': sectionTheme === THEME.APP })"
    :data-theme="sectionTheme"
  >
    <slot />
  </section>
</template>
